import InfoField from '../InfoField';
import PiezasList from '../PiezasList';
import { formatPrecio } from '../../utils';

const FullView = ({
    alternativa,
    piezas = [],
    precioOk,
    onCopyPiezaUrl,
}) => {
    const hasMultiplePiezas = piezas.length > 1;
    const hasPiezas = piezas.length > 0;
    const precioCompraLabel = hasMultiplePiezas
        ? 'Precio compra nuevo (total)'
        : 'Precio compra nuevo';
    const piezasLabel = hasMultiplePiezas
        ? 'Piezas alternativa'
        : 'Pieza alternativa';

    return (
        <>
            <div className="row g-3">
                <div className="col-md-4">
                    <InfoField
                        label="Nº Presupuesto Alternativa"
                        value={alternativa?.numero_presupuesto ?? '-'}
                    />
                </div>
                <div className="col-md-4">
                    <InfoField
                        label={precioCompraLabel}
                        value={formatPrecio(alternativa?.precio_compra_nuevo)}
                    />
                </div>
                <div className="col-md-4">
                    <InfoField
                        label="Tipo envío"
                        value={alternativa?.tipo_envio ?? '-'}
                    />
                </div>
                <div className="col-md-4">
                    <InfoField
                        label="Importe envío"
                        value={formatPrecio(alternativa?.importe_envio)}
                    />
                </div>
                <div className="col-md-4">
                    <InfoField
                        label="¿Precios cuadran?"
                        value={
                            <span
                                style={{
                                    color: precioOk ? '#399256' : '#d32f2f',
                                    fontWeight: 600,
                                }}
                            >
                                {precioOk ? 'SÍ' : 'NO'}
                            </span>
                        }
                    />
                </div>
            </div>
            {hasPiezas && (
                <div
                    className={`row ${hasMultiplePiezas ? 'mt-3' : 'mt-0'} g-3`}
                >
                    <div className="col-md-12">
                        <InfoField
                            label={piezasLabel}
                            value={
                                <PiezasList
                                    piezas={piezas}
                                    variant="alternativa"
                                    onCopyPiezaUrl={onCopyPiezaUrl}
                                    precioVentaTotal={
                                        alternativa?.precio_venta_nuevo
                                    }
                                />
                            }
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default FullView;
